import { debounce } from 'lodash'
import React, { Component } from 'react'
import GeneralStore from 'stores/GeneralStore'
import CargosStore from 'stores/CargosStore'
import EditingCargoStore from 'stores/EditingCargoStore'
import CategoryStore from 'stores/CategoryStore'
import InstantBookingStore from 'stores/InstantBookingStore'
import Footer from 'components/Footer'
import CargoDialog from 'components/CargoDialog'
import Spinner from 'components/Spinner'
import TopMenu from 'components/TopMenu'
import InstantBookingAwayModal from 'components/InstantBookingAwayModal'
import ActionCreators from 'actions/ActionCreators'

import "babel-polyfill"

import './Application.scss'

function getStateFromStores() {
    return {
        isWidgetMode: GeneralStore.isWidgetMode(),
        isLoading: GeneralStore.isLoading(),
        isIsraelModeOn: GeneralStore.isIsraelModeOn(),
        editingCargo: EditingCargoStore.getEditingCargo(),
        selectedCategory: CategoryStore.getSelected(),
        deliveryCargos: CargosStore.getDeliveryCargos(),
        showInstantBookingAwayModal: InstantBookingStore.showAwayModal(),
        showInstantBookingLoader: InstantBookingStore.showLoader(),
        isInstantBookingEmailCompleted: InstantBookingStore.emailCompleted(),
    }
}

/**
 * Корневой компонент приложения.
 * Содержит в себе обвязку страницы (шапку, подвал), модальное окно.
 * Дочерними элементами компонента становятся обработчики текущего маршрута.
 */

class Application extends Component {

    constructor(props) {
        super(props)
        this._debouncedResize = debounce(this._resize, 150)
    }

    state = getStateFromStores()

    componentWillMount() {
        GeneralStore.addChangeListener(this._onChange)
        CargosStore.addChangeListener(this._onChange)
        EditingCargoStore.addChangeListener(this._onChange)
        CategoryStore.addChangeListener(this._onChange)
        InstantBookingStore.addChangeListener(this._onChange)

        window.addEventListener('resize', this._debouncedResize)

        this._resize()
    }

    componentWillUnmount() {
        GeneralStore.removeChangeListener(this._onChange)
        CargosStore.removeChangeListener(this._onChange)
        EditingCargoStore.removeChangeListener(this._onChange)
        CategoryStore.removeChangeListener(this._onChange)
        InstantBookingStore.removeChangeListener(this._onChange)

        window.removeEventListener('resize', this._debouncedResize)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    _resize = () => {
        this.setState({
           isMobile: window.innerWidth < 768,
        })
    }

    _onMouseMove = (event) => {
        if (event.clientY <= 0 &&
            !this.state.isLoading &&
            !sessionStorage.getItem('vv_hide_instant_prices_feedback') &&
            /\/instant\/?$|\/instant-final-info\/?$|\/instant-contacts\/?$/.test(this.props.location.pathname) &&
            !this.state.showInstantBookingLoader &&
            this.state.isInstantBookingEmailCompleted
        ) {
            sessionStorage.setItem('vv_hide_instant_prices_feedback', '1')
            ActionCreators.showInstantBookingAwayModal()
        }
    }

    render() {

        let navigation = null
        let categoryId = ''
        let footer = null
        let instantBookingAwayModal = null

        const isSocialAuthPath = this.props.location.pathname.indexOf('social_auth') > 0
        const isSuccessPath = this.props.location.pathname.indexOf('success') > 0

        if (this.state.selectedCategory) {
            categoryId = this.state.selectedCategory.name
        }


        if (!isSocialAuthPath && !this.state.isWidgetMode) {
            footer = (
                <Footer isIsraelModeOn={this.state.isIsraelModeOn}/>
            )
        }

        let header = null
        if (!this.state.isWidgetMode) {
            header = <TopMenu location={this.props.location}/>
        }

        if (this.state.showInstantBookingAwayModal) {
            instantBookingAwayModal = (
                <InstantBookingAwayModal />
            )
        }

        return (
            <div className="Application" onMouseMove={this._onMouseMove}>
                {header}

                {navigation}

                {this.props.children
                    && React.cloneElement(this.props.children, getStateFromStores())}

                {this.state.editingCargo ?
                    <CargoDialog
                        deliveryCargos={this.state.deliveryCargos}
                        cargo={this.state.editingCargo}
                        selectedCategory={this.state.selectedCategory} /> : ''
                }

                {this.state.isLoading ?
                    <Spinner /> : null
                }

                {footer}

                {instantBookingAwayModal}
            </div>
        )
    }
}

export default Application



// WEBPACK FOOTER //
// ./client/components/Application/Application.js